<template>
  <div id="nav" @click="isTime">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      lastTime: null, // 最后一次点击的时间
      currentTime: null, // 当前点击的时间
      timeOut: 30 * 60 * 1000 * 16, // 设置超时时间: 8小时
    };
  },
  created() {
    this.lastTime = new Date().getTime();
  },
  methods: {
    //一定时间不操作退出
    isTime() {
      this.currentTime = new Date().getTime(); // 记录这次点击的时间
      if (this.currentTime - this.lastTime > this.timeOut) {
        // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
        if (
          sessionStorage.getItem("token") != "" &&
          sessionStorage.getItem("token") != null
        ) {
          // 如果是登录状态
          sessionStorage.clear();
          this.$router.push({ path: "/" });
        } else {
          this.lastTime = new Date().getTime();
        }
      } else {
        this.lastTime = new Date().getTime(); // 如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
      }
    },
  },
};
</script>


<style lang="less">
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#nav {
  width: 100%;
  height: 100vh;
}
</style>
